<div class="card-container">
    @if (this.payMethodInfo != null) {
    <table>
        <tr>
            <td rowspan="3">
                @if (this.payMethodInfo != null && cardIcon != null) {
                    <fa-icon [style.opacity]="1" size="8x" [icon]="cardIcon" [style.marginRight.px]="10" [style.opacity]="cardOpacity" style="font-weight: 900;"></fa-icon>
                }
            </td>
            <td class="card-label">{{payMethodInfo?.last4}}</td>
            <td>Powered by:</td>
        </tr>
        <tr>
            <td style="width: 150px">{{payMethodInfo?.expiration}}</td>
            <td class="fintech-label">{{payMethodInfo?.fintech}}</td>
        </tr>
        <tr>
            <td colspan="2">{{payMethodInfo?.cardholder}}</td>
        </tr>
    </table>

    <table>
        <tr>
            <td>Address:</td>
            <td colspan="3">{{payMethodInfo?.address1}} {{payMethodInfo?.address2}}</td>
        </tr>
        <tr>
            <td>City:</td>
            <td>{{payMethodInfo?.city}}</td>
            <td>State:</td>
            <td>{{payMethodInfo?.state}}</td>
        </tr>
        <tr>
            <td>Postal:</td>
            <td>{{payMethodInfo?.postalCode}}</td>
            <td>Country:</td>
            <td>{{payMethodInfo?.country}}</td>
        </tr>
    </table>
    }
    @else {
        <div style="color: gray;">Empty</div>
    }
</div>
